"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var platform_1 = require("./platform");
var enableTracking = function (id, enable) {
    if (enable === void 0) { enable = true; }
    if (!platform_1.IS_BROWSER)
        return;
    window["ga-disable-" + id] = (!enable).toString();
};
exports.default = enableTracking;
//# sourceMappingURL=enableTracking.js.map